import styled, { css } from 'styled-components';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { Typography } from '../../../global/theme';
import { AlignCenter, FlexCenter } from '../../../global/commonStyle';

interface Props {
  isActive?: boolean;
  isTrackingActivity?: boolean;
}

const Menu = styled.div`
  position: relative;
  padding: var(--space-5) var(--space-8) var(--space-5) var(--space-6);
  display: inline-flex;
  gap: var(--space-12);
  justify-content: space-between;
  cursor: pointer;
  border-radius: 8px;
  &:hover {
    background: var(--background-hover-navbar);
  }
  ${(props: Props) =>
    props.isActive &&
    css`
      background-color: var(--background-active-navbar);
      &:hover {
        background-color: var(--background-active-navbar);
      }
    `}
  ${mobile_xl(css`
    height: auto;
    padding: var(--space-11) var(--space-12) var(--space-11) var(--space-8);
    width: 100%;
    max-width: -webkit-fill-available;
    justify-content: space-between;
    border-radius: 4px;
    &:hover {
      background: transparent;
    }
  `)}
`;

const Left = styled.div<Props>`
  width: 100%;
  ${AlignCenter}
  gap: var(--space-12);
  ${mobile_xl(css`
    gap: var(--space-8);
  `)}
`;

const Label = styled.span`
  ${Typography.body_md_medium};
  color: var(--text-primary);
  ${mobile_xl(css`
    width: auto;
    white-space: nowrap;
    ${Typography.body_xl_medium};
  `)}
`;

const Right = styled.div`
  width: max-content;
  ${FlexCenter}
  ${Typography.body_sm};
  color: var(--text-secondary);
  ${mobile_xl(css`
    color: var(--text-primary);
  `)}
`;
const Icon = styled.div`
  ${FlexCenter}
  ${mobile_xl(css`
    svg {
      width: 20px;
      height: 20px;
    }
  `)}
`;
export { Label, Left, Menu, Right, Icon };
